export default __webpack_public_path__ + "static/media/fitnesstracker.912b4ca8.gif";